import { BusinessModel } from '@/entities/user/models/BusinessModel'

import { GridTypeName } from '../models/GridTypeName'

type GridTypeIDs = {
  [GridTypeKey in GridTypeName]: {
    [BusinessModelKey in BusinessModel]: number
  }
}

const gridTypeIDs: GridTypeIDs = {
  planningInbox: { 1: 1, 3: 2 },
  scenarioUnassigned: { 1: 3, 3: 4 },
  planningShift: { 1: 5, 3: 6 },
  runsheetUnassigned: { 1: 7, 3: 8 },
  runsheetShift: { 1: 9, 3: 10 },
  csRunsheet: { 1: 11, 3: 12 },
  closeRs: { 1: 13, 3: 14 },
}


/**
 * Retrieves the table grid id based on the business model and grid type
 */
export const getGridTypeId = (businessModelId: BusinessModel, gridTypeName: GridTypeName) : number => {
  return gridTypeIDs[gridTypeName][businessModelId] 
}
